import { MarketoFormMap } from "./marketoMap";

const createMarketoFormEl = (marketoFormId) => {
  const formInstance = document.createElement("form");
  $(formInstance).attr("id", `mktoForm_${marketoFormId}`);
  $(formInstance).css("display", "none");

  if (MarketoFormMap) {
    for (const [key, value] of Object.entries(MarketoFormMap)) {
      if (value === marketoFormId) {
        setTimeout(() => {
          $(`form[name="${key}"]`).parent().addClass("form-send");
        }, 5000);
      }
    }
  }

  $("#marketo-form-area").append(formInstance);
};

export const marketoFormSetup = (marketoFormId) => {
  const MarketoBaseURL = "//info.industriousoffice.com";
  const MarketoMunchkinId = "349-JNN-804";

  //  if the form has been loaded, then no need to load it again
  const loadedMarketoForm = MktoForms2.getForm(marketoFormId);

  if (loadedMarketoForm) {
    return loadedMarketoForm;
  }

  //  create an element for the LoadForm function to hook onto
  createMarketoFormEl(marketoFormId);

  return new Promise((resolve) => {
    MktoForms2.loadForm(
      MarketoBaseURL,
      MarketoMunchkinId,
      marketoFormId,
      (mkForm) => {
        resolve(mkForm);
      }
    );
  });
};
